import { NONE, WALL_PANEL_ID, WALL_EDGING_STRIP_CUSTOMIZABLE_ID } from 'domain/Options/generators/splashbacks';
import { NO_KITCHEN_ISLAND_ID, KITCHEN_ISLAND_ID } from 'domain/Options/generators/kitchenIslands';
import { NO_OVERHANG_ID } from 'domain/Options/generators/overhangs';
export const shape = 'shape';
export const material = 'material';
export const expression = 'expression';
export const coverPanel = 'coverPanel';
export const edge = 'edge';
export const wallLocation = 'wallLocation';
export const thickness = 'thickness';
export const doubleSided = 'doubleSided';
export const splashback = 'splashback';
export const wallEdgingStripCustomizable = 'wallEdgingStripCustomizable';
export const wallPanelMaterial = 'wallPanelMaterial';
export const wallEdgingStripMaterial = 'wallEdgingStripMaterial';
export const wallEdgingStripCustomizableMaterial = 'wallEdgingStripCustomMaterial';
export const wallPanelExpression = 'wallPanelExpression';
export const sinkMaterial = 'sinkMaterial';
export const sinkModel = 'sinkModel';
export const sinkFastening = 'sinkFastening';
export const drainerGrooves = 'drainerGrooves';
export const cutout = 'cutout';
export const freestandingHob = 'freestandingHob';
export const roundedCorner = 'roundedCorner';
export const invertedCorner = 'invertedCorner';
export const singleCut = 'singleCut';
export const doubleCut = 'doubleCut';
export const tripleCut = 'tripleCut';
export const highCabinetJoint = 'highCabinetJoint';
export const wallPanelRoundCutSmall = 'wallPanelRoundCutSmall';
export const wallPanelRoundCutBig = 'wallPanelRoundCutBig';
export const wallPanelSquareCut = 'wallPanelSquareCut';
export const wallPanelSingleCut = 'wallPanelSingleCut';
export const wallPanelDoubleCut = 'wallPanelDoubleCut';
export const wallPanelTripleCut = 'wallPanelTripleCut';
export const tapHole = 'tapHole';
export const plannedShape = 'plannedShape';
export const kitchenIsland = 'kitchenIsland';
export const kitchenIslandMaterial = 'kitchenIslandMaterial';
export const kitchenIslandExpression = 'kitchenIslandExpression';
export const kitchenIslandCoverPanel = 'kitchenIslandCoverPanel';
export const kitchenIslandEdge = 'kitchenIslandEdge';
export const kitchenIslandThickness = 'kitchenIslandThickness';
export const kitchenIslandDoubleSided = 'kitchenIslandDoubleSided';
export const kitchenIslandSplashBack = 'kitchenIslandSplashBack';
export const kitchenIslandOverhang = 'kitchenIslandOverhang';
export const kitchenIslandOverhangSide = 'kitchenIslandOverhangSide';
export const kitchenIslandSingleCut = 'kitchenIslandSingleCut';
export const kitchenIslandRoundedCorner = 'kitchenIslandRoundedCorner';
export const kitchenIslandSquareCut = 'kitchenIslandSquareCut';
export const kitchenIslandWallLocation = 'kitchenIslandWallLocation';
export const overhang = 'overhang';
export const overhangSide = 'overhangSide';

export const kitchenIslandSameAsWorktop = 'kitchenIslandSameAsWorktop';
export const wallPanelMatchWorktop = 'wallPanelMatchWorktop';

export const objectParameters = [
  material,
  expression,
  coverPanel,
  edge,
  wallLocation,
  thickness,
  sinkMaterial,
  sinkModel,
  sinkFastening,
  drainerGrooves,
  splashback,
  wallEdgingStripCustomizable,
  wallPanelMaterial,
  wallEdgingStripMaterial,
  wallEdgingStripCustomizableMaterial,
  wallPanelExpression,
  kitchenIsland,
  kitchenIslandMaterial,
  kitchenIslandExpression,
  kitchenIslandCoverPanel,
  kitchenIslandEdge,
  kitchenIslandThickness,
  overhang,
  overhangSide,
  kitchenIslandOverhang,
  kitchenIslandOverhangSide,
  kitchenIslandWallLocation,
];

export const wallPanelOperations = [
  wallPanelRoundCutSmall,
  wallPanelRoundCutBig,
  wallPanelSquareCut,
  wallPanelSingleCut,
  wallPanelDoubleCut,
  wallPanelTripleCut,
];

export const kitchenIslandOperations = [
  kitchenIslandSingleCut,
  kitchenIslandRoundedCorner,
  kitchenIslandSquareCut,
];

export const numericParameters = [
  cutout,
  freestandingHob,
  roundedCorner,
  invertedCorner,
  singleCut,
  doubleCut,
  tripleCut,
  highCabinetJoint,
  tapHole,
  ...wallPanelOperations,
  ...kitchenIslandOperations,
];

export const boolParameters = [
  kitchenIslandSameAsWorktop,
  wallPanelMatchWorktop,
  kitchenIslandDoubleSided,
  doubleSided,
  kitchenIslandSplashBack,
];

const saveKitchenIsland = (plan) => plan.getIn([kitchenIsland, 'value', 'id']) !== NO_KITCHEN_ISLAND_ID;
const saveSplashback = (plan) => plan.getIn([splashback, 'value', 'id']) !== NONE;
const saveSink = (plan) => plan.getIn([sinkMaterial, 'value', 'id']) !== 'noSink';
const saveOverhang = (plan) => plan.getIn([overhang, 'value', 'id']) !== NO_OVERHANG_ID;
const saveKitchenIslandOverhang = (plan) => plan.getIn([kitchenIslandOverhang, 'value', 'id']) !== NO_OVERHANG_ID;

export const shouldSerializeParameter = {
  [sinkModel]: saveSink,
  [sinkFastening]: saveSink,
  [drainerGrooves]: saveSink,
  [wallPanelExpression]: saveSplashback,
  [wallPanelMaterial]: saveSplashback,
  [wallEdgingStripMaterial]: saveSplashback,
  [wallEdgingStripCustomizableMaterial]: saveSplashback,
  wallPanelHeight: (plan) => plan.getIn([splashback, 'value', 'id']) === WALL_PANEL_ID,
  wallPanelStripHeight: (plan) => plan.getIn([splashback, 'value', 'id']) === WALL_EDGING_STRIP_CUSTOMIZABLE_ID,
  kitchenIslandMeasurements: (plan) => plan.getIn([kitchenIsland, 'value', 'id']) === KITCHEN_ISLAND_ID,
  overhangMeasurements: saveOverhang,
  [kitchenIsland]: saveKitchenIsland,
  [kitchenIslandMaterial]: saveKitchenIsland,
  [kitchenIslandExpression]: saveKitchenIsland,
  [kitchenIslandCoverPanel]: saveKitchenIsland,
  [kitchenIslandEdge]: saveKitchenIsland,
  [kitchenIslandThickness]: saveKitchenIsland,
  [kitchenIslandOverhang]: saveKitchenIslandOverhang,
  [kitchenIslandOverhangSide]: saveKitchenIslandOverhang,
  [overhang]: saveOverhang,
  [overhangSide]: saveOverhang,
  [kitchenIslandSameAsWorktop]: saveKitchenIsland,
  [wallPanelMatchWorktop]: saveSplashback,
  freestandingHobMeasurements: (plan) => plan.getIn([freestandingHob, 'value']) !== 0,
};

export const allParameters = objectParameters.concat(numericParameters).concat([plannedShape]);
